import { Skeleton } from '@mui/material';
import { FC } from 'react';
import { VerificationSummary } from '../../../../services/insurance/types/verification-summary';
import { ApptRequestIvStatusButtonProps } from './status-button';
import { ApptRequestIvStatusButtonSelector } from './status-button-selector';
import { UnknownIvStatusButton } from './unknown-status-button';

export interface ApptRequestIvStatusButtonFactoryProps {
  loading?: boolean;
  locationId?: number;
  apptRequestId: number;
  ivSummary: VerificationSummary | undefined;
  isUnknown?: boolean;
}

export const ApptRequestIvStatusButtonFactory: FC<ApptRequestIvStatusButtonFactoryProps> = (props) => {
  const { loading, apptRequestId, locationId, ivSummary, isUnknown } = props;

  if (loading) return <Skeleton variant="text" sx={{ fontSize: '22px', width: '100px' }} />;

  if (!locationId) return null;

  if (!ivSummary)
    return <UnknownIvStatusButton apptRequestId={apptRequestId} locationId={locationId} isUnknown={isUnknown} />;

  const buttonProps = {
    locationId,
    appointmentRequestId: apptRequestId,
    ivSummary
  } as Partial<ApptRequestIvStatusButtonProps>;

  return <ApptRequestIvStatusButtonSelector {...buttonProps} />;
};
